import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import PageHeader from '../components/ui/PageHeader'
import SMSProvidersTab from '../components/sms/SMSProvidersTab'
import SMSTemplatesTab from '../components/sms/SMSTemplatesTab'
import SMSTestMessageTab from '../components/sms/SMSTestMessageTab'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabPanel: React.FC<TabPanelProps> = ({ children, index, value }) => (
  <Box role="tabpanel" hidden={value !== index} sx={{ pt: 3 }}>
    {value === index && children}
  </Box>
)

const SMSConfigurationPage: React.FC = () => {
  const [tab, setTab] = useState(0)
  const [testTemplateId, setTestTemplateId] = useState<string | undefined>(undefined)

  const handleSelectForTest = (templateId: string) => {
    setTestTemplateId(templateId)
    setTab(2) // Switch to Test Messages tab
  }

  return (
    <Box>
      <PageHeader
        title="SMS & DLT Gateway"
        subtitle="Single source of truth for SMS gateways, DLT content template IDs, live character calculations, and test dispatches"
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Gateways & Credentials" />
          <Tab label="DLT Templates & IDs" />
          <Tab label="Send Test SMS" />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0}>
        <SMSProvidersTab />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <SMSTemplatesTab onSelectForTest={handleSelectForTest} />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <SMSTestMessageTab initialTemplateId={testTemplateId} />
      </TabPanel>
    </Box>
  )
}

export default SMSConfigurationPage
